<template>
    <div class="checkbox-control" :class="{ 'readonly': readonly }" @click="toggle()">
        <div class="checkbox-button" 
            :class="{ 'checked': isEnabled }"
            :style="{ '--boxColor': boxColor, '--checkColor': checkColor, '--iconColor': iconColor }">
            <b-icon icon="check2" v-if="isEnabled"></b-icon>
        </div>
        <div class="checkbox-label">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    model: {
        prop: 'isEnabled',
        event: 'toggle'
    },
    props: {
        isEnabled: Boolean,
        boxColor: {
            type: String,
            default: '#555'
        },
        checkColor: {
            type: String,
            default: '#4285f4'
        },
        iconColor: {
            type: String,
            default: '#fff'
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        toggle() {
            if (!this.readonly) {
                this.$emit('toggle', !this.isEnabled);
                this.$emit('change', !this.isEnabled);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@/Variable.scss';

$checkBoxSize: 25px;
$boxColor: var(--boxColor);
$checkColor: var(--checkColor);
$iconColor: var(--iconColor);

.checkbox-control {
    display: flex;
    flex-direction: row;
    cursor: pointer;
    
    .checkbox-button {
        width: $checkBoxSize;
        height: $checkBoxSize;
        background: $boxColor;
        @include transition(all 0.1s linear);

        &.checked {
            background: $checkColor;
            color: $iconColor;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
        }
    }

    .checkbox-label {
        margin-left: 10px;
    }

    &.readonly {
        cursor: default;
    }
}
</style>